module.exports = __webpack_public_path__ + "media/images/front/icon_05_arrow2_wh-976cd1f81154d089fcd2c12d03e5ca06.png";